<template>
  <div>
    <form>
      <ShowErrors
        :errorMessages="errorMessages"
      />

      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" name="email" class="form-control form-control-lg"
          placeholder="Email" v-model="user.email" v-validate="'required|email'">
        <span v-show="errors.has('email')" class="input-error">
          Please enter a valid email address.
        </span>
      </div>

      <div class="form-group">
        <label for="first_name">First Name</label>
        <input type="text" v-model="user.first_name" name="first_name"
          class="form-control form-control-lg" v-validate="'required|min:3'" />
        <span v-show="errors.has('first_name')" class="input-error">
          Please enter your first name.Please enter your first name.
        </span>
      </div>

      <div class="form-group">
        <label for="last_name">Last Name</label>
        <input type="text" v-model="user.last_name" name="last_name"
          class="form-control form-control-lg" v-validate="'required|min:3'" />
        <span v-show="errors.has('last_name')" class="input-error">
          Please enter your last name.
        </span>
      </div>

      <div class="form-group">
        <label for="password">Password</label>

        <input type="password" v-model="user.password" name="password"
          class="form-control form-control-lg" v-validate="'required|min:8'"
          ref="password" />
        <span v-show="errors.has('password')" class="input-error">
          {{ errors.first('password') }}
        </span>
      </div>

      <div class="form-group">
        <label for="password">Confirm Password</label>
        <input type="password" name="passwordConfirmation" v-validate="'required|confirmed:password'"
              data-vv-as="password" class="form-control form-control-lg" />
        <span v-show="errors.has('passwordConfirmation')" class="input-error">
          {{ errors.first('passwordConfirmation') }}
        </span>
      </div>

      <div class="checkbox">
        <input type="checkbox" id="terms" name="terms" v-model="user.terms"
          v-validate="'required'">
        <label for="terms">
          By registering I accept our

          <a href="javascript:;" @click="$bvModal.show('termsOfUseAndPrivacy')"
            style="color: #007bff;">
            Terms of Use and Privacy Policy
          </a>
        </label>
        <span v-show="errors.has('terms')" class="input-error">
          {{ errors.first('terms') }}
        </span>
      </div>
      <br/>
      <button type="button" class="btn btn-primary btn-lg" @click="validate()">
        Register
      </button>
    </form>
  </div>
</template>

<script>
import ShowErrors from '../common/ShowErrors'

export default {
  name: 'registration',
  components: {
    ShowErrors
  },
  data: function () {
    return {
      errorMessages: [],
      user: {
        email: null,
        password: null,
        first_name: null,
        last_name: null,
        terms: null
      }
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.register()
        }
      })
    },
    register: function () {
      var self = this
      this.error = false

      this.$http.post('registrations', { user: this.user }).then(function (response) {
        self.$router.push('/users/confirmation')
      }).catch(function (error) {
        if (error) {
          self.errorMessages = error.response.data.message
        }
      })
    }
  }
}
</script>
